import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { useAppDispatch, useAppSelecter } from "../../../hooks/storeHooks";
import mathFunction from "../../../pages/exams/mathFunction";
import { useNavigate, useLocation } from "react-router-dom";
//import { logoutUser } from "../store/slices/userDataSlice/thunks/logoutUser/logoutUser";
import globalColors from "../../../globalColors";
import CustomProgress from "../../CustomProgress";
const QueList: React.FC<{ setQue: any; question: any }> = ({
  setQue,
  question,
}) => {
  const dispatch = useAppDispatch();

  const questionsRef = useRef(null);
  const { status, proofReadingData } = useAppSelecter(
    (state) => state.questionsDataArraySlice
  );

  const token = localStorage.getItem("npc-admin-token")
    ? JSON.parse(localStorage.getItem("npc-admin-token") || "")
    : null;
  const [filterby, setFilterBy] = useState("all");

  // useEffect(() => {
  // if (proofReadingData === null && status === "IDLE")
  // handleLoadQuestiondDataArray({ currentPageNumber: 1 });
  // }, []);
  const navigate = useNavigate();
  const location = useLocation();

  //   useEffect(() => {
  //     if (
  //       location.pathname.includes("/preview/") &&
  //       location.pathname.includes("/editor")
  //     ) {
  //       navigate("/proofReading", { replace: true });
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, []);
  // useEffect(() => {
  //   handleLoadQuestiondDataArray({ currentPageNumber });
  // }, [currentPageNumber]);

  useEffect(() => {
    mathFunction();
    let timeOut: ReturnType<typeof setTimeout>;

    if (questionsRef.current) {
      timeOut = setTimeout(() => mathFunction(), 500);
    }

    return () => clearTimeout(timeOut);
  }, [proofReadingData, filterby]);

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilterBy((event.target as HTMLInputElement).value);
  };

  // if (proofReadingData === null) return null;

  const filteredQuestionsDataArray: any =
    proofReadingData === null
      ? []
      : filterby === "all"
      ? proofReadingData
      : proofReadingData.filter(
          (questionsData: { editStatus: string }) =>
            questionsData.editStatus === filterby
        );
  return (
    <Stack sx={{ height: "100%", width: "100%" }}>
      {/* filters */}
      <Stack marginTop={"2px"} p={"16px 16px 0 16px"}>
        <FormControl>
          <FormLabel sx={{ color: "#1f2937", fontWeight: 600, pb: "16px" }}>
            Questions
          </FormLabel>
        </FormControl>
      </Stack>

      <Divider sx={{ margin: "0 16px", width: "calc(100% - 32px)" }} />
      {/* questions list */}
      <List
        ref={questionsRef}
        className="scrollBluePrimarythin"
        sx={{
          overflowY: "auto",
          height: "calc(100% - 96.18px)",
          //  145.31px)",
          minHeight: "calc(100% - 96.18px)",
          padding: "0",
        }}
      >
        {status === "LOADING" ? (
          <Box
            sx={{
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CustomProgress
              sx={{ height: "30px !important", width: "30px !important" }}
            />
          </Box>
        ) : filteredQuestionsDataArray.length === 0 ? (
          <Box
            sx={{
              flex: "8",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              height: "100%",
            }}
          >
            <Typography variant="body1">No Questions Found</Typography>
          </Box>
        ) : (
          filteredQuestionsDataArray.map((questionData: any, i: number) => (
            <>
              <ListItem
                disablePadding
                key={questionData.questionId}
                sx={{
                  bgcolor:
                    question !== null &&
                    question?.questionId === questionData.questionId
                      ? globalColors.lavender[200]
                      : "",
                }}
              >
                <ListItemButton
                  onClick={(e) => {
                    e.stopPropagation();

                    setQue(questionData);
                  }}
                >
                  <ListItemText
                    sx={{ margin: "0" }}
                    primary={
                      <Stack direction={"row"} spacing={"16px"}>
                        <span
                          style={{
                            minWidth: "40px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "2px",
                            textAlign: "center",
                          }}
                        >
                          {questionData.questionId}
                          {questionData.editStatus === "completed" ? (
                            questionData.corrections !== null &&
                            Object.values(questionData.corrections).some(
                              (state) => state
                            ) ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <CheckCircleIcon
                                  sx={{
                                    color: "green",
                                    height: "18px",
                                    width: "18px",
                                  }}
                                />
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <ThumbUpAltIcon
                                  sx={{
                                    color: "green",
                                    height: "18px",
                                    width: "18px",
                                  }}
                                />
                              </Box>
                            )
                          ) : (
                            ""
                          )}
                        </span>
                        <Typography
                          sx={{
                            "& > :nth-child(1) p:first-of-type": {
                              margin: "0 !important",
                            },
                            "& > :nth-child(2) p:first-of-type": {
                              margin: "0 !important",
                            },
                            "& > :nth-child(1) p": {
                              margin: "0 !important",
                            },
                            "& > :first-child": {
                              margin: "0 !important",
                              "& > :first-child": {
                                margin: "0 !important",
                              },
                              "& > :second-child": {
                                margin: "0 !important",
                              },
                            },
                          }}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: questionData.question,
                            }}
                          ></div>
                        </Typography>
                      </Stack>
                    }
                  />
                </ListItemButton>
              </ListItem>
              {i + 1 !== filteredQuestionsDataArray.length && (
                <Divider
                  sx={{ margin: "0 16px", width: "calc(100% - 32px)" }}
                />
              )}
            </>
          ))
        )}
      </List>
      {/* page navigators */}

      {/* <
      Divider sx={{ margin: "0 16px", width: "calc(100% - 32px)" }} /> */}
      {/* <Stack
        direction={"row"}
        justifyContent={"space-between"}
        px={"16px"}
        my="5px"
      >
        <Button
          variant="contained"
        sx={{textTransform:"capitalize"}}
          disabled={currentPageNumber === 1 || status === "LOADING"}
          onClick={(e) => {
            e.stopPropagation();
            dispatch(goToPreviousPage());
          }}
        >
          previous
        </Button>
        <Typography
          textAlign={"center"}
          m="0"
          alignItems={"center"}
          display={"flex"}
        >
          {currentPageNumber}/10
        </Typography>
        <Button
          variant="contained"
        sx={{textTransform:"capitalize"}}
          disabled={currentPageNumber === 10 || status === "LOADING"}
          onClick={(e) => {
            e.stopPropagation();
            dispatch(goToNextPage());
          }}
        >
          next
        </Button>
      </Stack> */}
    </Stack>
  );
};
export default QueList;
